import { render } from "./AACT_Study_Comparison.vue?vue&type=template&id=168e698b&scoped=true"
import script from "./AACT_Study_Comparison.js?vue&type=script&lang=js"
export * from "./AACT_Study_Comparison.js?vue&type=script&lang=js"

import "./AACT_Study_Comparison.vue?vue&type=style&index=0&id=168e698b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168e698b"]])

export default __exports__